import { Box } from "@chakra-ui/react";
import { OperacaoEnum } from "core/resources/enums/conta";
import { useCallback, useState } from "react";

import useTransferencias from "features/transferencia/hooks/useTransferencias";
import TransferenciaTable from "components/TransferenciaTable";
import { useContaStore } from "features/conta/store";
import { TransferenciaItem } from "core/features/transferencia/typings";
import { useMemo } from "react";

interface ListaTransferenciasProps {
  selectedTransferenciaId?: string;
  valor: number | undefined;
  tenantContaIdExtrato: string;
  setValue: any;
}

export default function ListaTransferencias({
  selectedTransferenciaId,
  tenantContaIdExtrato,
  setValue,
}: ListaTransferenciasProps) {
  const {
    filters: { operacao, dataFim, dataInicio },
  } = useContaStore();

  const [filtro, setFiltro] = useState({ page: 1, limit: 10 });

  const {
    data: transferencias,
    isLoading: isLoadingTransferencias,
    isFetching: isFetchingTransferencias,
    refetch,
  } = useTransferencias({
    dataInicio: dataInicio!,
    dataFim: dataFim!,
    naoConciliado: "1",
    contaOrigemId:
      operacao === OperacaoEnum.Despesa ? tenantContaIdExtrato : undefined,
    contaDestinoId:
      operacao === OperacaoEnum.Receita ? tenantContaIdExtrato : undefined,
    ...filtro,
  });

  const onChangeSelectedRowsTransferencia = useCallback(
    (rows: TransferenciaItem[]) => {
      setValue("contas", []);
      setValue("transferenciaId", rows[0]?.id);
      setValue("transferencia", rows[0]);
    },
    [setValue]
  );

  const selectedTransferencia = useMemo(() => {
    return transferencias?.items.find(
      (transferencia) => transferencia.id === selectedTransferenciaId
    );
  }, [transferencias, selectedTransferenciaId]);

  return (
    <>
      <Box mt="16px" maxH="60vh">
        <TransferenciaTable
          defaultSelectedRows={
            selectedTransferencia ? [selectedTransferencia] : []
          }
          isLoading={isLoadingTransferencias || isFetchingTransferencias}
          transferencias={transferencias}
          showHeader={true}
          refetch={refetch}
          onChangePage={(page, limit) => setFiltro({ page, limit })}
          tableProps={{
            maxSelectedRows: 1,
            showCustomSelectionActions: false,
            customSelectedRows: {
              actions: [],
              handler: onChangeSelectedRowsTransferencia,
              selecteds: [],
            },
          }}
        />
      </Box>
    </>
  );
}
